import { Drawer, message, Spin } from "antd";
import { ReactComponent as LeftArrow } from "asset/mobile/alert_left_arrow_m.svg";
import style from "css/mobile/menu.module.css";
import axios from "axios";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import AlarmCard from "./alarmCard";
import { useTranslation } from "react-i18next";

function AlarmBar({ close, isOpen, payload }) {

    const { t } = useTranslation();
    const scrollViewRef = useRef(null);
    const isLoadingRef = useRef(true);

    const [alarmList, setAlarmList] = useState([]);
    // const [ghostlist, setghostlist] = useState([]);
    const [run, setrun] = useState(false);

    const getAlarmList = () => {
        let config = {
            params: {
                TARGET_USER: payload.id,
            },
        };
        axios
            .get("/alram/getalramlist", config)
            .then((res) => {
                if (res.status === 200) {
                    setAlarmList(res.data);
                    // setghostlist(res.data);

                    axios
                        .get("/alram/readalram", config)
                        .then((res) => {
                            if (res.status === 200) {
                            }
                        })
                        .finally(() => {
                            scrollViewRef.current.style.transform = `translateY(-50px)`;
                            isLoadingRef.current = false;
                            setrun(false);
                        });
                }
            })
            .finally(() => {
                scrollViewRef.current.style.transform = `translateY(-50px)`;
                isLoadingRef.current = false;
                setrun(false);
            });
    }

    useEffect(() => {
        if (isOpen) setrun(isOpen);
    }, [isOpen]);

    useEffect(() => {
        if (run) {
            getAlarmList();
        }
    }, [run]);

    const removeAlarm = (data) => {
        let config = {
            params: {
                ALRAM_NUM: data,
            },
        };

        axios.get("/alram/deletealram", config).then((res) => {
            if (res.status === 200) {
                const newdata = alarmList.filter((datas) => datas.ALRAM_NUM !== data);
                setAlarmList(newdata);
            }
        });
    };


    ///////// pullToRefresh //////////
    useLayoutEffect(() => {
        if (isOpen) {
            // DOM이 업데이트될 때까지 기다림
            if (scrollViewRef.current) {
                const main = document.querySelector(".scrollView-container-alarm");

                if (!main) {
                    message.error("Failed to load AlarmBar");
                    close();
                    return;
                }

                let scrollStart = 0;
                // let scrollMoving = 0;
                // let scrollEnd = 0;
                const pStart = { x: 0, y: 0 };
                const pCurrent = { x: 0, y: 0 };

                function loadData() {
                    if (isLoadingRef.current) return;

                    main.style.transform = `translateY(0px)`;

                    setTimeout(() => {
                        setrun(true);
                    }, 500)
                }

                function swipeStart(e) {
                    scrollStart = scrollViewRef.current.scrollTop;
                    let touch = e.targetTouches ? e.targetTouches[0] : e;
                    pStart.x = touch.screenX;
                    pStart.y = touch.screenY;
                }

                // function swipeEnd(e) {
                //     // scrollEnd = scrollViewRef.current.scrollTop;
                //     if (document.body.scrollTop === 0 && !isLoading) {
                //     }
                // }

                function swipe(e) {
                    // scrollMoving = scrollViewRef.current.scrollTop;
                    let touch = e.changedTouches ? e.changedTouches[0] : e;
                    pCurrent.x = touch.screenX;
                    pCurrent.y = touch.screenY;

                    let changeY = Math.max(0, pCurrent.y - pStart.y);

                    // main.style.transform = `translateY(${changeY}px)`;

                    if (document.body.scrollTop === 0) {
                        if (scrollStart === 0 && changeY > 100) {
                            loadData();
                        }
                    }
                }

                document.addEventListener("touchstart", swipeStart, false);
                document.addEventListener("touchmove", swipe, false);
                // iPhone에 기본 내려서 새로고침 막기
                // document.addEventListener("touchmove", (event) => { if (window.scrollY === 0) event.preventDefault() }, { passive: false });
                // document.addEventListener("touchend", swipeEnd, false);

                return () => {
                    document.removeEventListener("touchstart", swipeStart);
                    document.removeEventListener("touchmove", swipe);
                    // document.removeEventListener("touchend", swipeEnd);
                }
            }
        }
    }, [close, isOpen]);

    return (
        <Drawer
            style={{ height: "100%", width: "100%" }}
            placement='right'
            size='large'
            open={isOpen}
            onClose={close}
            closable={false}
            maskClosable={false}
            className="alarmMobile"
        >
            <div className={style.header_container}>
                <button className={style.back_btn} onClick={close}>
                    <LeftArrow />
                </button>
                <div>{t("ALARM.TITLE")}</div>
            </div>

            <div ref={scrollViewRef} className='scrollView-container-alarm'>
                <div className="scrollView-loading">
                    <Spin />
                </div>
                {/* <div className="scrollView-content"> */}
                {
                    alarmList.length > 0 ?
                        alarmList.map(alarm => (
                            <AlarmCard
                                key={alarm.ALRAM_NUM}
                                data={alarm}
                                removeAlarm={removeAlarm}
                            />
                        )) : "알림이 없습니다"
                }

                {/* </div> */}
            </div>
        </Drawer >

    )
}




export default AlarmBar
